const rankingItems = [
  { rank: 1, title: '爱在黎明破晓前', tag: '经典爱情', hot: '热度 9.8', change: 'up' },
  { rank: 2, title: '怦然心动', tag: '青春纯爱', hot: '热度 9.7', change: 'same' },
  { rank: 3, title: '婚姻故事', tag: '夫妻必看', hot: '热度 9.6', change: 'up' },
  { rank: 4, title: '时空恋旅人', tag: '奇幻浪漫', hot: '热度 9.5', change: 'up' },
  { rank: 5, title: '花束般的恋爱', tag: '日系纯爱', hot: '热度 9.4', change: 'down' },
  { rank: 6, title: '恋恋笔记本', tag: '催泪经典', hot: '热度 9.3', change: 'same' },
];

function getRankStyle(rank: number) {
  if (rank === 1) return 'bg-primary-500 text-white';
  if (rank === 2) return 'bg-primary-400 text-white';
  if (rank === 3) return 'bg-primary-300 text-white';
  return 'bg-background-200 text-foreground-500';
}

function getChangeIcon(change: string) {
  if (change === 'up') return <i className="ri-arrow-up-line text-accent-500 text-xs"></i>;
  if (change === 'down') return <i className="ri-arrow-down-line text-primary-500 text-xs"></i>;
  return <span className="w-3 h-3 flex items-center justify-center"><span className="block w-2 h-0.5 bg-foreground-300 rounded-full"></span></span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            大家都在看
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            热门榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            根据观影热度实时更新的夫妻必看影视排行榜
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 rounded-xl transition-colors duration-200 cursor-pointer group ${
                idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
              } hover:bg-background-200/70`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  {getChangeIcon(item.change)}
                </div>
                <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}